import { List } from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import getActionDeletarGrupo from 'src/actions/chats/getActionDeletarGrupo';

import { getStaff, getListaStaffsWithoutIsGroup, setSelectedChat, getChatInternoBuscarChat } from '../../../redux/slices/staff';
import { useDispatch, useSelector } from '../../../redux/store';
import ChatStaffItem from './ChatStaffItem';
import { setSessionStorageItem } from 'src/services/sessionStorage';
import v2_actionChatInternoBuscarChat from 'src/actions/v2/chats/chat-interno/v2_actionChatInternoBuscarChat';

const Contacts = ({
  chats,
  user,
  onlineUsers,
  roomsWithNewMessages,
  isOpenSidebar,
  onSelectConversation,
  deletarGrupo,
  selectedChat,
  contactList
}) => {
  return (
    <div className={`p-1 flex-1 overflow-y-scroll ${contactList ? 'w-full' : 'w-[390px]'} `}>
      {chats?.map((chat, index) => (
        <ChatStaffItem
          key={chat._id}
          chat={chat}
          user={user}
          onlineUsers={onlineUsers}
          deletarGrupo={() => handleDeletarGrupo(chat)}
          roomsWithNewMessages={roomsWithNewMessages}
          isOpenSidebar={isOpenSidebar}
          // isSelected={activeConversationId === conversationId}
          onSelectConversation={() => onSelectConversation(chat)}
          selectedChat={selectedChat}
          contactList={contactList}
        />
      ))}
    </div>
  );
};

export default function ChatInternoListaChats({ chats, user, isOpenSidebar, contactList, onCallback, ...other }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { roomsWithNewMessages, onlineUsers, selectedChat } = useSelector((state) => state.staff);

  async function buscarChatInterno(id) {
    let querys = `?limit=10&skip=0&msgs=1`
    const response = await v2_actionChatInternoBuscarChat(id, querys)
    if(response.status === 200) {
      console.log(response.data);
      setSessionStorageItem('chatInternoMiniId', response.data.room);
      //setSessionStorageItem('chatInternoMiniMessages', response.data.data)
    }
    }


    const handleChoose = async (chat) => {

      if (contactList) {
        buscarChatInterno(chat._id)
        onCallback();
        return;
      }
      const target = `/chats/interno/${chat._id}`;
      navigate(target);
      dispatch(getChatInternoBuscarChat(chat._id))
      
      //dispatch(getStaff(chat._id))
      dispatch(setSelectedChat(chat))
    }


    const handleDeletarGrupo = (chat) => {
      getActionDeletarGrupo({ chatId: chat._id }).then(() => {
        dispatch(getListaStaffsWithoutIsGroup())
      })
    }


    return (
      <Contacts
        chats={chats}
        user={user}
        onlineUsers={onlineUsers}
        roomsWithNewMessages={roomsWithNewMessages}
        isOpenSidebar={isOpenSidebar}
        onSelectConversation={handleChoose}
        deletarGrupo={handleDeletarGrupo}
        selectedChat={selectedChat}
        contactList={contactList}
      />
    )
  }
